import React, { useEffect, useState } from "react";
import { showError, showMessage } from "../ui/Message";
import { pubCall } from "../utils/PubSub";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import Nav from "../ui/Nav";
import { listen } from "../hooks/Listener";
import { SortIcon } from "../utils/Icons";
import Input from "../ui/Input";
import { requestPrompt } from "../utils/Utils";
import Bisacs from "../popovers/Bisacs";
import { createModal } from "../hooks/createModal";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { useTabs } from "../hooks/useTabs";
import { ROUTES } from "../utils/Routes";
import OrderSection from "./OrderSection";
import GLAccounts from "./GLAccounts";
import Confirm from "./Confirm";
import CategoryExtra from "./CategoryExtra";

export default function GlobalClassFile(props) {

    const NEW_ROW = { category_1: "", __new: true };

    const { controller = "", route = "", callback = () => { }, category_1 = "", category_2 = "", is_modal = false } = props;
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ sort: "category", limit: 45, dynamic: true, search_term: category_1 });
    const [align, setAlign] = useState("auto");
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [init, setInit] = useState(true);
    const buffer = 10;
    const [showBisac, setShowBisac] = useState(false);
    const [state, setState] = useState({
        edit: false,
        new: false,
    })

    const tableData = state.new ? [...data, NEW_ROW] : data;   

    const isNewRow = (row) => row?.__new === true || row?.category_id === "";

    const toInt = (value) => {
        const parsed = Number.parseInt(value, 10);
        return Number.isNaN(parsed) ? 0 : parsed;
    };

    const drawSearch = () => {
        requestPrompt({
            route: route, controller: controller, title: "Search", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {
                setFilters({ ...filters, "search_term": _s })
            }
        })
    }

    const defaultTabs = [
        { label: "category_1", key: "category_1", value: "" },
        { label: "category_2", key: "category_2", value: "" },
        { label: "section", key: "section", value: "" },
        { label: "tax_code", key: "tax_code", value: "" },
        { label: "discount", key: "discount", value: "" },
        { label: "frequent_buyer_points", key: "frequent_buyer_points", value: "" },
        { label: "receive_account", key: "receive_account", value: "" },
        { label: "sell_account", key: "sell_account", value: "" },
        { label: "profit_margin", key: "profit_margin", value: "" },
        { label: "description", key: "description", value: "" },
        // { label: "sequence", key: "sequence", value: "" },
    ]

    const drawMessage = () => {
        switch (index) {
            case "section": return <>Section code. End-of-day sales and GL will total activity by section codes.</>;
            case "tax_code": return <>1 = tax1 only, 2 = tax2 only, B = both taxes, blank = no tax, 3 = special</>;
            case "discount": return <>Normally blank. The POS will discount items in this class by this percentage.</>;
            case "frequent_buyer_points": return <>Blank (use default), 0 for no FB Reward, 1 to 99 cents earned on each $ spent</>;
            case "receive_account": return <>Optional: Special GL account to post Received goods from this class.</>;
            case "sell_account": return <>Optional: Special GL account to post Sales from this Class.</>;
            case "profit_margin": return <> If no Inventory cost found, the profit margin to use for cost of sales.</>;
            case "description": return <> An online description of this class for consumers.</>;
            // case "sequence": return <>Alpha-numeric code use to force a specific sequence of classes online</>;
            default: return <></>
        }
    }


    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "category_id");

    useEffect(() => {
        if (!state.new && !state.edit) return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });
    }, [index]);

    const cancelEditRow = () => {
        setState(s => ({ ...s, edit: false, new: false }));
        setTabs(defaultTabs);
    }


    const saveCategory = () => {
        const _info = {
            category_1: getVal("category_1"),
            category_2: getVal("category_2"),
            section: getVal("section"),
            tax_code: getVal("tax_code"),
            discount: toInt(getVal("discount")),
            frequent_buyer_points: getVal("frequent_buyer_points"),
            receive_account: getVal("receive_account"),
            sell_account: getVal("sell_account"),
            profit_margin: getVal("profit_margin"),
            description: getVal("description"),
            sequence: selected.sequence,
            category_id: selected?.category_id === undefined ? "" : selected?.category_id,
        }

       

        if (state.edit) {
            pubCall("category.update", {category_id: selected?.category_id,  category_info: _info}, (_s, _r) => {
                if (_s) {
                    showMessage("Category updated");
                    const updatedRow = { ..._info, category_id: selected?.category_id };
                    setData((prev) => prev.map((item) => item?.category_id === selected?.category_id ? { ...item, ...updatedRow } : item));
                    setSelected((prev) => prev?.category_id === selected?.category_id ? { ...prev, ...updatedRow } : prev);
                    setState(s => ({ ...s, edit: false, new: false }));
                } else {
                    showError(_r);
                }
            })
        } else if (state.new) {
            pubCall("category.create", { category_info: _info }, (_s, _r) => {
                if (_s) {
                    showMessage("Category created");
                    setState(s => ({ ...s, edit: false, new: false }));
                    fetchInitial();
                } else {
                    showError(_r);
                }
            })
        }
    };

    const showNewRow = () => {
        setState(s => ({ ...s, edit: false, new: true }));
        setSelected(NEW_ROW);
        setIndex("category_1");
        requestAnimationFrame(() => {
            refs.current?.category_1?.focus?.();
        });
    };


    const showEditRow = () => {
        if (selected?.category_id) {
            setTabs([
                { label: "category_1", key: "category_1", value: selected.category_1 || "" },
                { label: "category_2", key: "category_2", value: selected.category_2 || "" },
                { label: "section", key: "section", value: selected.section || "" },
                { label: "tax_code", key: "tax_code", value: selected.tax_code || "" },
                { label: "discount", key: "discount", value: selected.discount ?? "" },
                { label: "frequent_buyer_points", key: "frequent_buyer_points", value: selected.frequent_buyer_points || "" },
                { label: "receive_account", key: "receive_account", value: selected.receive_account || "" },
                { label: "sell_account", key: "sell_account", value: selected.sell_account || "" },
                { label: "profit_margin", key: "profit_margin", value: selected.profit_margin || "" },
                { label: "description", key: "description", value: selected.description || "" },
                // { label: "sequence", key: "sequence", value: selected.sequence || "" },
            ]);
            setState(s => ({ ...s, edit: true, new: false }));
            setIndex("category_1");
            requestAnimationFrame(() => {
                refs.current?.category_1?.focus?.();
            });
        }
    }

    const edit_nav = [
        { key: KBD.ESCAPE, action: () => cancelEditRow() },
        { key: KBD.ENTER, action: () => index === "description" ? saveCategory() : next() },
        { key: KBD.PAGE_DOWN, action: () => saveCategory() },
        { key: KBD.PAGE_UP, action: () => openPopover() },
        { key: KBD.ARROW_DOWN, action: () => { next() } },
        { key: KBD.TAB, action: () => { next() } },
        { key: KBD.ARROW_UP, action: () => { prev() } },
    ]

    const nav = [
        { key: KBD.ESCAPE, action: () => { callback() } },
        { key: KBD.ENTER, action: (e) => { if (is_modal) { callback(selected) } } },
        { key: KBD.B, text: "Bisac", action: () => { window.bm_state.value = ROUTES.HELPERS.BISACS; setShowBisac(true) } },
        ...(window.beta ? [{ text: "Del" }] : [{ text: "Del", key: KBD.D, action: () => { removeCategory() } }]),
        ...(window.beta ? [{ text: "New" }] : [{ text: "New", key: KBD.N, action: showNewRow }]),
        ...(window.beta ? [{ text: "Edt" }] : [{ text: "Edt", key: KBD.E, action: showEditRow }]),
        { text: "Indx", key: KBD.I, action: () => { if (filters.sort === "category") { setAlign("start"); setFilters({ ...filters, "sort": "section", "dynamic": true }) } else { setAlign("start"); setFilters({ ...filters, "sort": "category", "dynamic": true }) } } },
        { text: "Prnt" },   
        ...(window.beta ? [{ text: "Srch" }] : [{ key: KBD.S, text: "Srch", action: () => { drawSearch() } }]),
        { text: "Upd" },
        ...(window.beta ? [{ text: "Xtra" }] : [{ text: "Xtra", key: KBD.X, action: () => { openExtra() } }]),
    ]

    const canEditRow = (row) => {
        if (isNewRow(row) && state?.new) return true;

        if (state?.edit && row?.category_id === selected?.category_id) return true;

        return false;
    }

    const openExtra = () => {
        window.bm_state.value = ROUTES.ORDERS.EXTRA;
        createModal({
            component: <CategoryExtra controller={controller} route={ROUTES.ORDERS.EXTRA} />, closable: true, title: "Xtra Options",
            callback: (option) => {
                if (option) {
                    fetchInitial();

                }
                window.bm_state.value = route;
            }
        })
    }

    const openPopover = () => { 

        switch (index) {

            case "section":
                window.bm_state.value = ROUTES.ORDERS.SECTION_CODE;
                refs.current["section"].blur();
                createModal({
                    closable: true,
                    title: "Section Codes",
                    component: <OrderSection 
                        controller={controller}
                        route={ROUTES.ORDERS.SECTION_CODE}
                        signal={props.signal}
                    />,
                    callback: (e) => {
                        if (e) {
                            update("section", e?.account);
                        }
                        refs.current["section"].focus();
                        window.bm_state.value = route;
                    }
                })
            break;

            case "receive_account":
            case "sell_account":
                window.bm_state.value = ROUTES.ORDERS.GL_ACCOUNT;
                createModal({
                    component: 
                        <GLAccounts 
                            controller={controller} 
                            route={ROUTES.ORDERS.GL_ACCOUNT} 
                        />, 
                        title: "GL Accounts", 
                        closable: true, 
                        callback: (e) => {
                        if (e) {
                            if (index === "receive_account") {
                                update("receive_account", e?.account);
                            } else if (index === "sell_account") {
                                update("sell_account", e?.account);
                            }
                        }
                        window.bm_state.value = route;
                        }
                })
            break;
        }
    }


    const colSort = (_text, _key, _current, _callback = () => { }) => {
        const match = (_current === _key);
        if (!match) {
            return (<div onClick={() => _callback(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => _callback(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }

    const columns = [
        {
            key: "class", align: "left", title: colSort("Classification", "category", filters.sort, (_key) => setFilters({ ...filters, "sort": _key, "dynamic": true })), width: 270, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input className="fill" tabMax={() => next()} style={{ width: "120px" }} maxLength={8} {...editProps("category_1")} edit={true}/> - <Input tabMax={() => next()} style={{ width: "120px" }} maxLength={8} className="fill" {...editProps("category_2")} edit={true}/></>
                } else {
                return <>{f.category_1} - {f.category_2}</>
            }
        }},
        { key: "section", title: colSort("SE", "section", filters.sort, (_key) => setFilters({ ...filters, "sort": _key, dynamic: true })), width: 50, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input uppercase className="fill" {...editProps("section")}  maxLength={2} edit={true}/></>
            } else {
                return <>{f.section.toUpperCase()}</>
            }
        }},
        { key: "tax_code", title: <>TX</>, width: 45, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" chars={["1", "2", "B", "0", "3", " "]} tabMax={() => next()}{...editProps("tax_code")}  maxLength={1} edit={true}/></>
            } else {
                return <>{f.tax_code}</>
            }
        }},
        { key: "discount", title: <>%%</>, width: 45, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" number={true} maxLength={2} tabMax={() => next()}{...editProps("discount")} edit={true}/></>
            } else {
                return <>{f.discount}</>
            }
        }},
        { key: "frequent_buyer_points", title: <>Pnts</>, width: 60, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("frequent_buyer_points")} edit={true}/></>
            } else {
                return <>{f.frequent_buyer_points}</>
            }
        }},
        { key: "receive_account", title: <>Rcv</>, width: 45, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("receive_account")} edit={true}/></>
            } else {
                return <>{f.receive_account}</>
            }
        }},
        { key: "sell_account", title: <>Sls</>, width: 45, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("sell_account")} edit={true}/></>
            } else {
                return <>{f.sell_account}</>
            }
        }},
        { key: "profit_margin", title: <>PM%</>, width: 45, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("profit_margin")} edit={true}/></>
            } else {
                return <>{f.profit_margin}</>
            }
        }},
        { key: "description", align: "left", title: <>Description</>, grow: true, width: 298, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("description")} style={{ width: 335 }} edit={true}/></>
            } else {
                return <>{f.description}</>
            }
        }},
        // { key: "sequence", title: <>Seq</>, width: 45, render: (e, f) => {
        //     if (canEditRow(f)) {
        //         return <><Input className="fill" {...editProps("sequence")} edit={true}/></>
        //     } else {
        //         return <>{f.sequence}</>
        //     }
        // }},

    ]

    const removeCategory = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Remove Category?"} route={ROUTES.HELPERS.CONFIRM}/>, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("category.remove", { category_id: selected?.category_id }, (_s, _r) => {
                        if (!_s) return showError(_r);
                        showMessage("Category removed successfully");
                        const newData = data.filter(item => item?.category_id !== selected?.category_id);
                        setData(newData);
                        if (newData.length > 0) {
                            setSelected(newData[0]);
                        } else {
                            setSelected({});
                        }
                    })
                }
            }
        })
    }


    const fetchInitial = () => {
        if (loading) { return }
        setLoading(true);

        let _filters = { ...filters };
        let _api = "category.getInitial";
        if (filters?.search_term) {
            _filters.search_term = filters?.search_term;
            _api = "category.search";
        }

        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
                setLoading(false);
                if (_api === "category.search") {
                    setFilters({ ...filters, "search_term": "" })
                }
            }
            setInit(false);
            setLoading(false)
        });
    }


    const fetchLast = () => {
        if (loading) { return }
        setLoading(true);

        alert(JSON.stringify(filters, null, 2))

        let _filters = { ...filters };
        let _api = "category.getLast";
        if (category_1 && init) {
            _filters.search_term = category_1;
            _api = "category.search";
        }

        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setAlign("auto");
                }
                setData(_r);
                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
            } else {
                showError(_r);
            }
            setInit(false);
            setLoading(false)
        });
    }


    useEffect(fetchInitial, [filters])

    useEffect(() => {
        const actions = (state.new || state.edit) ? edit_nav : nav;
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.PAGE_DOWN, KBD.PAGE_UP, KBD.TAB]);
        return cleanup;
    }, [index, tabs, refs, state.new, state.edit, selected, data])


    const nextType = (_rows = 1) => {

        if (data.length === 0) { setSelected({}); return; }

        setAlign("auto")
        const nextIndex = data.findIndex(item => item?.category_id === selected?.category_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prevType = (_rows = 1) => {
        setAlign("auto")
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.category_id === selected?.category_id) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading || state.new || state.edit) { return }
        setLoading(true);
        pubCall("category.getNext", { ...filters, "limit": 20, "category_id": data[data.length - 1]?.category_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || state.new || state.edit) { return }
        setLoading(true);
        pubCall("category.getPrevious", { ...filters, "limit": 20, "category_id": data[0]?.category_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }



    if (showBisac) {
        return (<>
            <Bisacs controller={controller} route={ROUTES.HELPERS.BISACS} modal callback={() => {

                window.bm_state.value = ROUTES.GLOBAL.CLASSFILE;
                setShowBisac(false)
            }} />
        </>)
    }

    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                onRowDoubleClick={() => { if (is_modal) { callback(selected) } }}
                next={nextType}
                prev={prevType}
                getStart={() => fetchInitial()}
                getEnd={() => fetchLast()}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
                onLoadMore={(_start, _end, _prepend) => {
                    if (state.new || state.edit) return;
                    if (_prepend) {
                        if (data?.length > 0 && data[0]?.number !== 1) {
                            fetchPrev()
                        }
                    } else {
                        if (data?.length > 0) {
                            fetchNext();
                        }

                    }
                }}
                align={align}
                row_key={"category_id"}
                current={selected}
                data={tableData}
                columns={columns}
                width={918}
                loading={loading}
                offset={458}
                route={route}
            />
            <div className="shim" style={{ "height": "4px" }} />
            {(state.new || state.edit) && <Status type="active"><InfoIcon />{drawMessage()}</Status>}
            {(!state.new && !state.edit) && <div style={{ "marginBottom": "-8px" }}><Nav nav={nav} /></div>}
        </>
    )


}
